import { useTranslation } from 'react-i18next';

import {
    Button,
    Modal,
    ModalComponent,
    ModalProps,
} from '@speeki/global-ui-components';

import { IncidentTypesListDocument } from '@graphql/generated/graphql';

import { useQuery } from '@apollo/client';
import { currentLanguageVar } from '@boot/reactiveVariables';
import { SingleIncidentType } from '@domains/new-conversation/atoms/SingleIncidentType/SingleIncidentType';

import {
    ModalDescription,
    ModalList,
    ModalTitle,
} from './IncidentTypesModal.styled';

interface IncidentTypesModalProps
    extends Pick<ModalProps, 'onClose' | 'open'> {}

export const IncidentTypesModal = ({
    onClose,
    open,
}: IncidentTypesModalProps) => {
    const { t } = useTranslation();

    const { data } = useQuery(IncidentTypesListDocument, {
        context: {
            notifyOnError: true,
        },
        variables: {
            targetLanguage: currentLanguageVar(),
        },
    });
    const incidentTypes = data?.tenant.incidentTypes || [];

    return (
        <ModalComponent
            closeButton
            onClose={onClose}
            open={open}
            preventCloseEsc
            preventCloseOutside
            width={648}
        >
            <Modal.Content>
                <ModalTitle center>{t('INCIDENT_TYPES')}</ModalTitle>
                <ModalDescription>
                    {t('INCIDENT_TYPES_DESCRIPTION')}:
                </ModalDescription>
                <ModalList>
                    {incidentTypes.map((incidentType) => (
                        <SingleIncidentType {...incidentType} />
                    ))}
                </ModalList>
            </Modal.Content>
            <Modal.Footer>
                <Modal.ButtonsWrapper>
                    <Button
                        onClick={onClose}
                        testId={'button_close'}
                        variant={'primary'}
                    >
                        {t('CLOSE')}
                    </Button>
                </Modal.ButtonsWrapper>
            </Modal.Footer>
        </ModalComponent>
    );
};
